import { displayNameOrShort } from '../../lib/displayName';
import type { LabelResolver } from '../../hooks/useLabelResolver';
import type { RoleAssignmentInfoLocal } from '../../api/types/MeLocal';
import { UNNAMED_ROLE } from '../../lib/labelConstants';

/** Nombre del rol de una asignación; sin nombre, un texto en español en vez del id. */
export function assignmentRoleName(a: RoleAssignmentInfoLocal): string {
    return a.roleName?.trim() || UNNAMED_ROLE;
}

/** Alcance legible de una asignación: tenant o «nivel: destino», nunca la clave cruda. */
export function assignmentScopeLabel(a: RoleAssignmentInfoLocal, labels: LabelResolver): string {
    if (a.scope === 'PLATFORM') return labels.scope('PLATFORM');
    const target = displayNameOrShort(a.scopeRefName, a.scopeRef);
    if (a.scope === 'TENANT') {
        const name = labels.scope('TENANT', a.scopeRef);
        return name && name !== a.scopeRef && name !== a.scope ? name : target;
    }
    return `${labels.scope(a.scope, a.scopeRef)}: ${target}`;
}
